import { endOfMonth, format, startOfMonth } from 'date-fns';

export const getCommissionMonthLabel = (date: Date = new Date()): string =>
  `${format(date, 'MMM')} commission`;

export const getCommissionDateRange = (date: Date = new Date()): string =>
  `${format(startOfMonth(date), 'd')}–${format(endOfMonth(date), 'd MMM yyyy')}`;
